import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/app_logo.png" alt="" className="footer-logo-icon" aria-hidden="true" />
              Quit <span>Gooning</span>
            </div>
            <p className="footer-desc">
              The private, offline app to quit porn addiction and stop gooning.
              No accounts. No cloud. Your recovery stays on your device.
              Available free on iOS and Android.
            </p>
          </div>
          <div className="footer-nav-group">
            <p className="footer-nav-label">App</p>
            <a
              href="https://play.google.com/store/apps/details?id=com.extendztech.quit_gooning"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </a>
            <a href="https://apps.apple.com/pk/app/quit-gooning/id6758883662" target="_blank" rel="noopener noreferrer">App Store</a>
          </div>
          <div className="footer-nav-group">
            <p className="footer-nav-label">Legal</p>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/support">Support</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} Quit Gooning. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/support">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
